import { Key } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { useEmployeeProfile } from '~/data/employeeProfile';
import { AccountManagementMenu_OnUpdateLegacy } from '~/library/AccountManagementMenu/component';

import { useResetPassword } from './useResetPassword';

type Props = AccountManagementMenu_OnUpdateLegacy & {
  open: boolean;
  onClose: () => void;
};

export const ResetPassword = ({ open, onClose, onUpdateLegacy }: Props) => {
  const { t } = useTranslation();

  const { profile } = useEmployeeProfile();
  const getTitleWithEmployeeName = useCallback(
    (title) =>
      !!profile ? `${title} - ${profile.firstName} ${profile.lastName}` : title,
    [profile],
  );

  const onSubmitSuccess = useCallback(() => {
    if (!!onUpdateLegacy) {
      onUpdateLegacy(['resetPassword']);
    }
    onClose();
  }, [onUpdateLegacy, onClose]);

  const { onSubmit } = useResetPassword({ onSubmitSuccess });

  return (
    <Dialog open={open} onClose={onClose}>
      <SolaForceDialogTitle onClose={onClose} icon={<Key />}>
        {getTitleWithEmployeeName(t('laResetPassword'))}
      </SolaForceDialogTitle>
      <DialogContent dividers={true}>
        <Typography>{t('laConfirmPasswordReset')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color={'secondary'}>
          {t('cancel')}
        </Button>
        <Button onClick={onSubmit}>{t('laConfirm')}</Button>
      </DialogActions>
    </Dialog>
  );
};
